var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.apiCount>0))?_c('div',{staticClass:"loading",attrs:{"id":"loading"}},[_c('img',{staticClass:"loading_img",attrs:{"src":require("../../assets/loading.gif")}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }